import { combineReducers, } from 'redux';
import { routerReducer, } from 'react-router-redux';

import signup from './signup';
import signin from './signin';
import auth from './auth';
import dashboard from './dashboard';
import parcel from './parcel';
import shipment from './shipment';
import estimate from './estimate';
import address from './address';
import checkout from './checkout';
import cms from './cms';
import settings from './settings';
import cart from './cart';

const rootReducer = combineReducers(
    {
        signup, 
        signin, 
        auth, 
        dashboard, 
        parcel, 
        shipment, 
        estimate, 
        address,
        checkout,
        cms,
        routing:routerReducer, 
        settings,
        cart,
    }
);

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/